import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
  },
  sectionHeading: {
    marginBottom: theme.spacing(4),
  },
  sectionDescription: {
    marginBottom: theme.spacing(4),
    fontSize: '1.125rem',
    lineHeight: 1.6,
  },
  video: {
    width: '100%',
  },
  [theme.breakpoints.up('md')]: {
    video: {
      height: '600px',
      objectFit: 'cover',
    },
  },
  [theme.breakpoints.down('xs')]: {
    videoContainer: {
      '& video': {
        height: '75vh',
        objectFit: 'cover',
      },
    },
  },
  sectionHeadingContainer: {
    textAlign: 'center',
    padding: theme.spacing(4, 0),
  },
  featureheading: {
    alignItems: 'center',
  },
  featureLink: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
      marginTop: theme.spacing(2),
    },
  },
  section: {
    textAlign: 'center',
  },
  sectionLink: {
    display: 'flex',
    alignItems: 'end',
    justifyContent: 'end',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  productInfoContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    marginBottom: '80px',
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(3),
      flexDirection: 'column',
      '& > div': {
        width: '100% !important',
      },
    },
  },
}))
